import React from "react";
import CashGamesInfo from "src/components/Poker/CashGamesInfo";

const TitanCashGamesInfo = () => <CashGamesInfo />;

export default TitanCashGamesInfo;
